import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import Styles from './styles';

import useI18n from '../../../../utils/use-i18n';
import ContentEnglish from './i18n/en';
import ContentSpanish from './i18n/es';

const content = {
    en: ContentEnglish,
    es: ContentSpanish,
};


const DifficulityBlock = ({ classes, difficulty }) => {
    const Easy = useI18n('easy', content);
    const Medium = useI18n('medium', content);
    const Hard1 = useI18n('hard_1', content);
    const Hard2 = useI18n('hard_2', content);
    const Hard3 = useI18n('hard_3', content);
    return (
        <div className={`${classes.wrapper} ${classes[`difficulty${difficulty}`]}`}>
            {difficulty === 3 && <Typography className={classes.text}>{Easy}</Typography>}
            {difficulty === 2 && <Typography className={classes.text}>{Medium}</Typography>}
            {difficulty === 1 && <Typography className={classes.text}>{Hard1} <span className={classes.highlight}>{Hard2}</span> {Hard3}</Typography>}
        </div>
    );
};
DifficulityBlock.defaultProps = {
    difficulty: 0,
};

DifficulityBlock.propTypes = {
    classes: PropTypes.object.isRequired,
    difficulty: PropTypes.number,
};


export default withStyles(Styles)(DifficulityBlock);
